<!--
 * @Description: 组件描述
 * @Author: 房旭 
 * @LastEditors: 房旭
 * @Date: 2019-02-25 16:04:48
 * @LastEditTime: 2019-04-16 14:36:39
 -->
<template>
    <div class="user">
        <img :src="avatar?(hosts+avatar):require('../assets/images/default_avatar.jpg')" alt="">
        <div class="detail">
            <div class="detail_item"><span class="key">姓名：</span><span class="value">{{username}}</span></div>
            <!-- <div class="detail_item"><span class="key">职务：</span><span class="value">{{job}}</span></div> -->
            <div class="detail_item"><span class="key">所属组织：</span><span class="value">{{orgName}}<span v-if="host != undefined">({{host
                        === 1 ? '主责部门': '配合部门'}})</span></span></div>
        </div>
        <i-button class="estimate_btn" type="primary" v-if="showEstimateBtn&&isexception==2" @click="clickEstimate">评价</i-button>
        <div class="state" v-if="isexception==0">已评价</div>
    </div>
</template>

<script>

    export default {
        props: {
            username: String, //用户姓名
            job: String, //用户职务
            orgName: String, //用户所属部门
            avatar: String,//头像
            host: Number,//是否为主责部门
            showEstimateBtn: {//是否显示评价按钮
                type: Boolean,
                default: false
            },
            isexception: Number//评价状态
        },
        data() {
            return {
                hosts: ''//主机
            };
        },
        components: {},
        methods: {
            //点击评价事件
            clickEstimate() {
                this.$emit('on-clickEstimate')
            }
        }
    };
</script>

<style scoped lang="less">
    .user {
        // height: 70px;
        display: flex;
        flex: 0 0 290px;

        >img {
            width: 70px;
            height: 70px;
            border-radius: 50%;
            margin-right: 10px;
            flex: 0 0 70px;
        }

        .detail {
            align-self: flex-start;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // padding: 6px 0;
            flex: 1;
            margin-left:20px ;

            .detail_item {
                // white-space: nowrap;
                // overflow: hidden;
                // text-overflow: ellipsis;
                font-size: 12px;
                line-height: 24px;
                // min-height: 12px;
                // margin-top: -5px;
                display: flex;

            }
        }

        .estimate_btn {
            position: absolute;
            top: 80px;
            left: 10px
        }

        .state {
            position: absolute;
            top: 80px;
            left: -10px;
            color: #ff9600;
            font-size: 16px;
            padding-left: 20px;
        }
    }
</style>